module.exports = __webpack_public_path__ + "img/safe_tool_04.9b4b2504.jpg";